import toast from "react-hot-toast";
import axiosInstance from "../../../axiosInstance";
import { secureStorage } from "../../../utils/secureStorage";

export const loginApi = (FormData, setFormData, navigate, setIsLoading) => {
  setIsLoading(true);
  axiosInstance
    .post("/auth/login", FormData)
    .then((res) => {
      if (res.data.success) {
        toast.success(res.data.message);
        secureStorage.setItem("user", res.data.user);
        secureStorage.setItem("accessToken", res.data.token);
        navigate(-1);
        setIsLoading(false);
      } else {
        toast.error(res.data.message);
        setIsLoading(false);
      }
    })
    .catch((err) => {
      toast.error(err.response.data.message);
    });
};

export const registerApi = (FormData, setFormData, navigate, setIsLoading) => {
  setIsLoading(true);
  axiosInstance
    .post("/auth/register", FormData)
    .then((res) => {
      if (res.data.success) {
        toast.success(res.data.message);
        setFormData({
          fullName: "",
          email: "",
          phoneNumber: "",
          password: "",
          isCustomer: 1,
          isWelcomed: 1,
          status: 1,
          createdAt: new Date().toISOString(),
        });
        navigate(-1);
        setIsLoading(false);
      } else {
        toast.error(res.data.message);
        setIsLoading(false);
      }
    })
    .catch((err) => {
      toast.error(err.response.data.message);
      setIsLoading(true);
    });
};

export const forgotPasswordApi = (FormData, navigate, setIsLoading) => {
  setIsLoading(true);
  axiosInstance
    .post("/auth/forgot-password", FormData)
    .then((res) => {
      if (res.data.message === "Email sent successfully") {
        toast.success(res.data.message);
        setIsLoading(false);
      }
    })
    .catch((err) => {
      toast.error(err.response.data.message);
      setIsLoading(false);
    });
};

export const authorizedToken = (token, navigate) => {
  axiosInstance
    .get(`/auth/reset-password/${token}`)
    .then((res) => {
      if (res.data.message === "Authorized Token") {
        toast.success("Change your password");
      } else {
        navigate("/authentication/forget-password");
      }
    })
    .catch((err) => {
      toast.error(err.response.data.message);
    });
};

export const changePassword = (FormData, token, navigate, setIsLoading) => {
  setIsLoading(true);
  axiosInstance
    .post(`/auth/reset-now/${token}`, FormData)
    .then((res) => {
      if (res.data.message === "Password updated successfully") {
        toast.success(res.data.message);
        navigate("/authentication/signin");
        setIsLoading(false);
      } else {
        toast.error(res.data.message);
      }
    })
    .catch((err) => {
      toast.error(err.response.data.message);
      setIsLoading(false);
    });
};
